import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import redIMG from '../../../img/servicioTecnico/red.png';
import sosIMG from '../../../img/servicioTecnico/sos.png';
import garantiaIMG from '../../../img/servicioTecnico/garantia.png';
import iconCotizar from '../../../img/floating/cotizar.svg';
import iconAgendar from '../../../img/floating/agendar.svg';
import iconGarantia from '../../../img/floating/garantia_black.png';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/foter/footer';

import { Col, Container, Row } from 'react-bootstrap';

import '../../../css/formulariosPredefined.css'
import './servicioTecnico.css'
import Red from '../../components/servicioTecnico/red';
import Garantia from '../../components/servicioTecnico/garantia';
import Sos from '../../components/servicioTecnico/sos';
import { Breadcrumb, Button } from 'antd';
import { Link, useParams } from 'react-router-dom';
import Seo from '../../components/seo/seo';
import CentrosMantencion from '../../components/centrosMantencion/centrosMantencion';
import botonAsistencia from '../../../img/asistencia/asistenciaEnLinea.png';
import botonAsistenciaM from '../../../img/asistencia/necesitas_asistencia_mobile.png';
import { useSliderServicio } from '../../../hooks/Front/servicioTecnico/useServicios';
import Noticias from '../../components/nosotros/noticias';



const ServicioTecnico = () => {
    const { seccion } = useParams();
    const [componenteActual, setComponente] = useState("garantia");
    const { sliders, error } = useSliderServicio();
    const queryState = useSelector((state) => state.query.search);

    const [componenteAMostrar, setComponenteAMostrar] = useState(<Red />)
    useEffect(() => {
        switch (componenteActual) {
            case "red":
                setComponenteAMostrar(<Red />)
                window.history.pushState('/servicio-tecnico', '', `/servicio-tecnico/red-de-servicios${queryState ? ("?" + queryState) : ""}`);
                break;
            case "garantia":
                setComponenteAMostrar(<Garantia />)
                window.history.pushState('/servicio-tecnico', '', `/servicio-tecnico/garantia-y-mantencion${queryState ? ("?" + queryState) : ""}`);
                break;
            case "sos":
                setComponenteAMostrar(<Sos />)
                window.history.pushState('/servicio-tecnico', '', `/servicio-tecnico/garantia-hyundai-camiones-y-buses${queryState ? ("?" + queryState) : ""}`);
                break;
            case "recalls":
                setComponenteAMostrar(<Noticias modulo={'SERV_TECNICO'} />)
                window.history.pushState('/servicio-tecnico', '', `/servicio-tecnico/campanas-y-recalls${queryState ? ("?" + queryState) : ""}`);
                break;
            default:
                break;
        };
    }, [componenteActual])
    

    useEffect(() => {
        if (seccion) {
            switch (seccion) {
                case 'garantia-y-mantencion':
                    setComponente('garantia');                    
                    break;
                case 'red-de-servicios':
                    setComponente('red');                    
                    break;
                case 'garantia-hyundai-camiones-y-buses':
                    setComponente('sos');                    
                    break;
                case 'campanas-y-recalls':
                    setComponente('recalls');                    
                    break;            
                default:
                    break;
            }
        }
    }, [seccion]);

    return (
        <>
            <Navbar whatsappVisible={true} />
            <CentrosMantencion seccion="SERV_TECNICO" />
            <Seo title="Servicio técnico -" />
            <Container fluid className="mb-general">
                <Row>
                    <Col className="my-1 my-md-3 px-2 mb-3 ">
                        <Breadcrumb separator=">" className="f-responsive-10">
                            <Breadcrumb.Item><Link to="/" className="parrafo-hyundai text-dark f-responsive-10">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item className="parrafo-hyundai text-dark f-responsive-10">
                                Servicio técnico
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} lg={12} className="mx-auto my-md-4 d-none d-md-block">
                        <Row>
                            {sliders && Array.isArray(sliders) && sliders.length > 0 && error === false &&
                                sliders.map((slider, index) =>
                                    <Col key={index} className="px-0 link-st" xs={3} onClick={() => setComponente(slider.Seccion.toLowerCase())}>
                                        <div className={`${componenteActual === slider.Seccion.toLowerCase() ? "overlay-st-activa" : "overlay-seccion-st"}`}></div>
                                        <img src={slider.Imagen} alt={slider.Seccion} className="img-fluid img-servicio" />
                                        <h2 className="bold-text-hyundai texto-card-servicio text-white txt-index-nosotros text-white txt-index-st">{slider.Titulo}</h2>
                                    </Col>
                                )
                            }
                        </Row>
                    </Col>
                    <Col xs={12} className="d-md-none mb-4">
                        <Row>
                            {sliders && Array.isArray(sliders) && sliders.length > 0 && error === false &&
                                sliders.map((slider, index) =>
                                    <Col key={index} className="px-0" xs={6} onClick={() => setComponente(slider.Seccion.toLowerCase())}>
                                        <div className={`${componenteActual === slider.Seccion.toLowerCase() ? "overlay-st-activa" : "overlay-seccion-st"}`}></div>
                                        <img src={slider.Imagen} alt={slider.Seccion} className="img-fluid w-100" />
                                        <h2 className="bold-text-hyundai texto-card-servicio text-white f-responsive txt-index-st">{slider.Titulo}</h2>
                                    </Col>
                                )
                            }

                            {/* <Col className="px-0" xs={4} onClick={() => setComponente("red")}>
                                <div className={`${componenteActual === "red" ? "overlay-st-activa" : "overlay-seccion-st"}`}></div>
                                <img src={redIMG} alt="red" className="img-fluid w-100 " />
                                <h2 className="bold-text-hyundai texto-card-servicio text-white txt-index-st f-responsive">Red<br />de Servicios<br /></h2>
                            </Col>
                            <Col className="px-0" xs={4} onClick={() => setComponente("garantia")}>
                                <div className={`${componenteActual === "garantia" ? "overlay-st-activa" : "overlay-seccion-st"}`}></div>
                                <img src={garantiaIMG} alt="garantia" className="img-fluid w-100 txt-index-st" />
                                <h2 className="bold-text-hyundai texto-card-garantia text-white f-responsive">Mantención<br />y Garantía<br /> </h2>
                            </Col>
                            <Col className="px-0" xs={4} onClick={() => setComponente("sos")}>
                                <div className={`${componenteActual === "sos" ? "overlay-st-activa" : "overlay-seccion-st"}`}></div>
                                <img src={sosIMG} alt="sos" className="img-fluid w-100" />
                                <h2 className="bold-text-hyundai texto-card-servicio text-white txt-index-st f-responsive">Información de<br />Garantía<br /></h2>
                            </Col> */}
                        </Row>
                    </Col>
                </Row>
                {componenteAMostrar}
            </Container>
            <BottomBar componenteActual={componenteActual} />
            <Footer float={true} />
        </>
    )
};


const BottomBar = ({ componenteActual }) => {
    return (
        <Container className="bg-hyundai-light fixed-bottom floating-shadow" fluid>
            {/* OCULAR OFF */}
            {/* {componenteActual && componenteActual === "sos" &&
                <Row>
                    <Col xs={12} className="px-0 d-none d-md-block">
                        <button className="ocular-toggler btn-asistencia">
                            <img src={botonAsistencia} alt="asistencia-hyundai" className="img-fluid" />
                        </button>
                    </Col>
                    <Col xs={12} className="px-0 d-block d-md-none">
                        <button className="ocular-toggler btn-asistencia">
                            <img src={botonAsistenciaM} alt="asistencia-hyundai" className="img-fluid" />
                        </button>
                    </Col>
                </Row>
            } */}
            <Row>
                <Col xs={4} className="px-0 min-h-floating floating-border-right">
                    <Link to="/agenda-tu-servicio">
                        <Button type="text" className="w-100 h-100 bold-title-hyundai px-0">
                            <img src={iconAgendar} alt="Agenda tu servicio" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="color-float bold-title-hyundai d-none d-md-inline">Agenda tu servicio</h6>
                            <p className="color-float bold-title-hyundai mb-0 mt-1 font-floating-btn d-md-none color-btn-floating ">Agenda tu servicio</p>
                        </Button>

                    </Link>
                </Col>
                <Col xs={4} className="px-0 min-h-floating">
                    <Link to="/solicitar-garantia">
                        <Button type="text" className="w-100 h-100 bold-title-hyundai px-0">
                            <img src={iconGarantia} alt="Solicitar garantia" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="color-float bold-title-hyundai d-none d-md-inline">Solicitud garantía</h6>
                            <p className="color-float bold-title-hyundai mb-0 mt-1 font-floating-btn d-md-none color-btn-floating">Solicitud garantía</p>
                        </Button>
                    </Link>
                </Col>
                <Col xs={4} className="px-0 bg-cotizar-floating min-h-floating">
                    <Link to="/cotizar/mantencion">
                        <Button type="text" className="w-100 h-100 bold-title-hyundai px-0">
                            <img src={iconCotizar} alt="Cotizar mantención" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="t bold-title-hyundai d-none d-md-inline text-white">Cotizar mantención</h6>
                            <p className="bold-title-hyundai mb-0 mt-1 font-floating-btn d-md-none text-white">Cotizar mantención</p>
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
};

export default ServicioTecnico;